import React from 'react';
import {connect} from 'react-redux';

import moment from 'moment';
import { Table } from 'reactstrap';
// import './Schedule.css';

import { gameActions } from '../../actions';
import {getOrderedGames} from '../../selectors';

class Schedule extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            modal: false,
            currentPage: 1,
            gamesPerPage: 5
        }
    }

    componentDidMount(){
        this.props.fetchGames();
    }


    render(){
        return(
            <div>
                <div className="container">
                    <div className="row mt2 mb2">
                        <div className="col-md-12 tc">
                            <p>Below is a list of our games this month. Please take note of the times, arena & length of game as they vary. If you're interested in coming to play, please contact us at admin@tbayshinny.com letting us know which game(s) you'd like to attend </p>
                        </div>
                    </div>
                    <div className="row mb3">
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Arena</th>
                                    <th>Credit Cost</th>
                                    <th>Player Count</th>
                                    <th>Goalie Count</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.props.games.map((game,index) =>{
                                    return  <tr key={index}>
                                            <td>{moment(game.gameStartTime).format('dddd, MMMM DD, YYYY')}</td>
                                            <td>{moment(game.gameStartTime).format('h:mm a')} - {moment(game.gameEndTime).format('h:mm a')}</td>
                                            <td>{game.arena}</td>
                                            <td>{game.playerCost} player / {game.goalieCost} goalies</td>
                                            <td>{game.playerCount}/{game.maxPlayers}</td>
                                            <td>{game.goalieCount}/{game.maxGoalies}</td>
                                        </tr>;
                                })
                            }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        games: getOrderedGames(state)
    }
}

export default connect(mapStateToProps, gameActions)(Schedule);


// WEBPACK FOOTER //
// ./src/components/Schedule/Schedule.js